exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order_add[data-v-dad226f4]{font-size:14px;line-height:1.4;font-weight:700;color:rgba(0,0,0,.85)}.activity-order[data-v-dad226f4]{height:100%}.activity-order_footer[data-v-dad226f4]{padding:1rem 0}.edu_lvl .edu_lvl_text[data-v-dad226f4]{display:-ms-flexbox;display:flex;padding-bottom:9px}.edu_lvl .edu_lvl_text p[data-v-dad226f4]{font-size:14px}.edu_lvl .edu_lvl_text .hint[data-v-dad226f4]{padding-right:2px;color:red}.edu_lvl .form__select[data-v-dad226f4]{width:100%;margin-bottom:1rem;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dad226f4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/activities/card/order/ActivitesOrder.vue
// module id = e44cac54d2216399af30
// module chunks = 0